import { useEffect, useState } from 'react'
import { SidebarImport } from './Imports'
import * as Icons from 'react-icons/lu'
const { LuCircleDot, useDispatch, useSelector, Link, sidebarTodo, useNavigate, useLocation, SessionManager, useTranslation } = SidebarImport

export default function SidebarLayout(props) {

    const [loading, setLoading] = useState(true)

    const { t, i18n } = useTranslation()

    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.sidebar && state.sidebar.data)

    const { collapsed, setCollapsed } = props

    const Icon = ({ name }) => {
        const IconComponent = Icons[name];

        if (!IconComponent) {
            console.error(`Icon "${name}" not found.`);
            return null;
        }

        return <IconComponent className={i18n.language === 'ar' ? 'ms-2' : 'me-2'} style={{ marginBottom: '0.20rem' }} />;
    }

    const [isDropdownVisible, setIsDropdownVisible] = useState(false);

    const handleLinkClick = (main_menu_name) => {
        setIsDropdownVisible(false);
        SessionManager.setSession('main_menu', main_menu_name)
    };

    const sidebar_res = (res) => {
        if (res?.status === 200) {
            const permission = res?.data?.actionAttribtes?.map(val => JSON.parse(val)).flat()
            SessionManager.setSession('permission', JSON.stringify(permission))
            setLoading(false)
        } else {
            // setBreakLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(sidebarTodo({ navigate })).then((res) => sidebar_res(res.payload))
    }, [])

    useEffect(() => {
        const main_menu_name = data?.mainMenu?.find(mainMenu =>
            mainMenu?.subMenus?.some(subMenu =>
                subMenu?.permissionMenu?.some(permission => {
                    const actions = JSON.parse(permission?.rolePermissionSchema?.actionAttributes);
                    return actions?.some(action => action.route === location?.pathname);
                })
            )
        )?.name || null;

        SessionManager.setSession('main_menu', main_menu_name)
    }, [location?.pathname, data])

    return (
        <>
            <div className="navba">
                {data?.mainMenu?.map((main, index) =>
                    <div
                        className="dropdow"
                        key={index.toString()}
                        onMouseEnter={() => setIsDropdownVisible(true)}
                        onMouseLeave={() => setIsDropdownVisible(false)}
                    >
                        <button className={SessionManager.getSession('main_menu') === main?.name ? "dropbtn dropbtn_active" : "dropbtn"}>
                            <Icon name={main.icon} />
                            {main.name}
                            <Icons.LuChevronDown size={16} className={i18n.language === 'ar' ? "me-1" : "ms-1"} />
                        </button>
                        <div className="dropdown-content"
                            style={{ display: isDropdownVisible ? 'block' : 'none' }}
                        >
                            <div className="container-fluid">
                                <div className="row">
                                    {main?.subMenus?.map((sub, subIndex) =>
                                        <div className="col-md-6 column" key={index.toString() + subIndex.toString()}>
                                            <div className='sub-head'><LuCircleDot size={12} className={i18n.language === 'ar' ? "ms-1" : "me-1"} />{sub.name}</div>
                                            <hr />
                                            <div className="container-fluid">
                                                <div className="row">

                                                    {sub?.permissionMenu?.map((permit, permitIndex) =>
                                                        permit?.rolePermissionSchema?.actionAttributes && JSON.parse(permit?.rolePermissionSchema?.actionAttributes)
                                                            .filter(fil => fil.showInMenu === true)
                                                            .map((action, actIndex) =>

                                                                <div className="col-md-4 mb-1" key={index.toString() + subIndex.toString() + permitIndex.toString() + actIndex.toString()}>
                                                                    <Link
                                                                        to={action.route}
                                                                        className={location?.pathname === action.route ? 'action_active d-flex align-items-center' : 'd-flex align-items-center'}
                                                                        onClick={() => handleLinkClick(main?.name)}
                                                                    >
                                                                        <span><Icons.LuDot size={20} /></span>
                                                                        {action.actionName}
                                                                    </Link>
                                                                </div>
                                                            )).flat()
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </>
    )
}